import {useCallback} from "react"
import {useQuery, useQueryClient} from "@tanstack/react-query"
import {studentAccountService} from "services"
import {UNLIMITED_PAGE_SIZE} from "data/constants"
import {BankAccount} from "types/student-account/bank-account"

const queryCacheKey = "all-bank-accounts"
const INITIAL_DATA: BankAccount[] = []

export const useAllBankAccounts = () => {
    const queryClient = useQueryClient()

    const query = useQuery(
        [queryCacheKey],
        async () => {
            const {data} = await studentAccountService.getBankAccounts({
                filter: {},
                range: {
                    page: 1,
                    pageSize: UNLIMITED_PAGE_SIZE
                }
            })
            return data.map((item) => ({...item, id: item.accountId}))
        },
        {
            refetchOnMount: false
        }
    )
    return {
        bankAccounts: query.data ?? INITIAL_DATA,
        invalidateBankAccountsCache: useCallback(() => {
            queryClient.invalidateQueries({queryKey: [queryCacheKey]})
        }, [queryClient])
    }
}
